<template>
  <v-container class="my-16 px-16">
    <div>
      <h1>Contact Us</h1>
      <v-form ref="contactusform">
        <v-row class="mt-16">
          <v-col cols="12" lg="6">
            <v-text-field label="Name" v-model="message.name" outlined />
          </v-col>
          <v-col cols="12" lg="6">
            <v-text-field label="Email" v-model="message.email" outlined />
          </v-col>
          <v-col cols="12">
            <v-textarea label="Message" v-model="message.message" outlined />
          </v-col>
          <v-col>
            <v-btn
              :disabled="sending"
              :loading="sending"
              depressed
              :dark="!sending"
              large
              @click="send"
              >Submit</v-btn
            >
          </v-col>
        </v-row>
      </v-form>
    </div>
  </v-container>
</template>

<script>
import { getFirestore, addDoc, collection } from "firebase/firestore"

export default {
  data() {
    return {
      message: {
        name: null,
        email: null,
        message: null,
      },
      sending: false,
    }
  },
  methods: {
    async send() {
      if (!this.message.name || !this.message.email || !this.message.message) {
        return
      }
      this.sending = true
      const contactusCollection = collection(getFirestore(), "contactus")
      await addDoc(contactusCollection, this.message)
      this.sending = false
      this.$refs.contactusform.reset()
      this.$router.push("/")
    },
  },
}
</script>
